import { Box, BoxProps } from '@chakra-ui/react'

export const OpenEye = ({ width, height, ...props }: BoxProps) => {
    return (
        <Box cursor={'pointer'} {...props}>
            <svg width={`${width || '17'}`} height={`${height || '17'}`} viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_4040_17314)">
                    <path d="M1.57585 5.33333C1.57585 5.33333 4.56061 2 8.24251 2C11.9244 2 14.9092 5.33333 14.9092 5.33333" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
                    <path d="M14.6051 8.69674C14.8078 8.98095 14.9091 9.12306 14.9091 9.33341C14.9091 9.54377 14.8078 9.68588 14.6051 9.97009C13.6944 11.2471 11.3686 14.0001 8.24247 14.0001C5.11633 14.0001 2.79054 11.2471 1.87983 9.97009C1.67715 9.68588 1.57581 9.54377 1.57581 9.33341C1.57581 9.12306 1.67715 8.98095 1.87983 8.69674C2.79054 7.41971 5.11632 4.66675 8.24247 4.66675C11.3686 4.66675 13.6944 7.41971 14.6051 8.69674Z" stroke="currentColor" stroke-width="1.5" />
                    <path d="M10.2424 9.33325C10.2424 8.22868 9.347 7.33325 8.24243 7.33325C7.13786 7.33325 6.24243 8.22868 6.24243 9.33325C6.24243 10.4378 7.13786 11.3333 8.24243 11.3333C9.347 11.3333 10.2424 10.4378 10.2424 9.33325Z" stroke="currentColor" stroke-width="1.5" />
                </g>
                <defs>
                    <clipPath id="clip0_4040_17314">
                        <rect width="16" height="16" fill="white" transform="translate(0.242432)" />
                    </clipPath>
                </defs>
            </svg>
        </Box>
    )
}
